// src/stores/index.js
import { createPinia } from "pinia";

export const pinia = createPinia();
